<template>
  <div class="main-home">
    <NavBar/>   

    <div class="home">
      <CoverHome/>
    </div>

    <div class="container-fluid story-container">
      <div v-for="item in items_group" :key="item.item_id">
        <SingleCard v-if="item[0].item_type==`SingleCard`" :cardText="item[0]"/>

        <ScrollText  v-if="item[0].item_type==`ScrollText`" :cardText="item"/>

        <SwiperImages :items="item" v-if="item[0].item_type==`SwiperImages`" />

      </div>
    </div>
    <div class="container-fluid">
      <Relacionados/>
    </div>
    <div class="container-fluid enlaces">
      <Enlaces/>
    </div>
    <div class="container-fluid">
      <Footer />
    </div>
  </div>
</template>

<script>

import { groupBy } from 'lodash'

import NavBar from '@/components/NavBar.vue'
import CoverHome from '@/components/CoverHome.vue'
import ScrollText from '@/components/ScrollText.vue'
import SingleCard from '@/components/SingleCard.vue'
import Relacionados from '@/components/Relacionados.vue'
import Enlaces from '@/components/Enlaces.vue'
import Footer from '@/components/Footer.vue'
import SwiperImages from '@/components/SwiperImages.vue'


export default {
  name: 'Home',
  components: {
    NavBar,    
    ScrollText,
    SingleCard,
    CoverHome,    
    Footer,
    Enlaces,
    Relacionados,
    SwiperImages
  },
  data() {
    return {
      current_year: '2003',
      show_bar: false
    }
  },
  mounted() {    
    window.addEventListener('scroll', ()=> {
      window.requestAnimationFrame( ()=> {
        this.scrollAnimation(window.scrollY)
      })          
    })
    
  },
  computed: {
    items_group() {
      return groupBy(this.$t('items'), 'groupby')
    }
  },
  methods: {
    getAllContainer() {
      let  nuevo = document.querySelectorAll('.container-item')
      let triggers = Array.from(nuevo).map(item=>{
        return {
          name: item.dataset.name,
          start: item.offsetTop,
          end: item.offsetTop+item.offsetHeight,
          element: item,
          year: item.dataset.year
        }
      })
      return triggers
    },
    scrollAnimation(scroll) {
      
      let triggers = this.getAllContainer()      
      triggers.map(item=>{
        if(scroll >= item.start) {        
          if(scroll <= item.end) {
            this.current_year=item.year
            if(item.element.querySelector('.timeline-content')) {
              item.element.querySelector('.timeline-content').classList.add('active')              
            }                
          }
        }
      })
      if(scroll>= triggers[0].start) {
        if(scroll <= triggers[triggers.length-1].end) {
          this.show_bar=true
        } else {
          this.show_bar=false
        }
      } else {
        this.show_bar=false
      }

    }
  }
  
}
</script>